// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1401":"59c7332bb1fedc52","8041":"a64712fe42bf5767"}[chunkId] + ".css";
};